import $ from 'jquery';

const CURRENCY_GBP = 'GBP';
const CURRENCY_EUR = 'EUR';
const CURRENCY_USD = 'USD';

export default class JGApi {

    static getInstance(appId = '1f91dd7f') {
        if (!(appId in JGApi.instances)) {
            JGApi.instances[appId] = new JGApi(appId);
        }

        return JGApi.instances[appId];
    }

    constructor(appId) {
        this.appId = appId;
        this.requests = {};
    }

    _getPageDetailsUrl(pageName) {
        return `${this._getBaseUrl()}/fundraising/pages/${pageName}`
    }

    _getPageDonationsUrl(pageName) {
        return `${this._getBaseUrl()}/fundraising/pages/${pageName}/donations`
    }

    _getEventLeaderboardUrl(eventId, currency) {
        return `${this._getBaseUrl()}/event/${eventId}/leaderboard?currency=${currency}`
    }

    _getCharityLeaderboardUrl(charityId, currency) {
        return `${this._getBaseUrl()}/charity/${charityId}/leaderboard?currency=${currency}`
    }

    _getBaseUrl() {
        return `https://api.justgiving.com/${this.appId}/v1`;
    }

    _getResponseByUrl(url, refresh = false) {
        if (!(url in this.requests) || refresh) {
            this.requests[url] = this._getRequest(url);
        }
        return this.requests[url];
    }

    _getRequest(url) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                contentType: 'application/json'
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

    getPageDetails(pageId, refresh = false) {
        return this._getResponseByUrl(this._getPageDetailsUrl(pageId), refresh);
    }

    getPageDonations(pageId, refresh = false) {
        return this._getResponseByUrl(this._getPageDonationsUrl(pageId), refresh);
    }

    getEventLeaderboard(eventId, currency = CURRENCY_GBP) {
        return this._getResponseByUrl(this._getEventLeaderboardUrl(eventId, currency));
    }

    getCharityLeaderboard(charityId, currency = CURRENCY_GBP) {
        return this._getResponseByUrl(this._getCharityLeaderboardUrl(charityId, currency));
    }

    static getPageDonateUrl(pageName) {
        return `https://www.justgiving.com/fundraising/${pageName}/donate`;
    }

    static getCurrencySymbolByCode(code) {
        let currencies = {
            [CURRENCY_GBP]: "£",
            [CURRENCY_EUR]: "€",
            [CURRENCY_USD]: "$",
        };

        if (!(code in currencies)) {
            throw new Error('Unknown currency');
        }

        return currencies[code];
    }

    static getDefaultErrorMessage() {
        return `
<div class="jg-error__container">
<span class="jg-error">Sorry, we were unable to retrieve data. Please try again later.</span>
</div>
`;
    }
}

JGApi.instances = {};



// WEBPACK FOOTER //
// ./app/general/js/jg-api.js